import * as React from "react";
import Box from "@mui/material/Box";
// import axios from "axios";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import Popup from "reactjs-popup";

import { toast } from "react-toastify";
import { useState } from "react";
import { useEffect } from "react";

import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";

import Button from "@mui/material/Button";

import FileDownloadDoneIcon from "@mui/icons-material/FileDownloadDone";
import axiosInstance from "../../config/axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

const WalletManagement = () => {
  const [data, setData] = useState([]);

  const StorePendingList = () => {
    axiosInstance
      .post(
        `api/multivendor-pending-product-variants-list/`,
        {},
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        setData(response?.data?.multivendor_pending_product_variants_list);
        console.log(
          "pending data list==>",
          response?.data?.multivendor_pending_product_variants_list,
        );
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
        toast.error(error.message);
      });
  };

  useEffect(() => {
    StorePendingList();
  }, []);

  const approvadData = (ids) => {
    const fd = new FormData();
    fd.append("product_variant_id", ids);
    axiosInstance
      .post(`api/multivendor-approve-pending-product-variant/`, fd, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        toast.success(response?.data?.message);
        StorePendingList();
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
        toast.error(error.message);
      });
  };

  return (
    <>
      <div className="!bg-white">
        <div className="flex justify-between !bg-slate-100">
          <div className="p-2">
            <p className="text-xl font-bold !text-black">
              Pending Product Variant Approval List
            </p>
            <p className="!text-black">
              View/Search Pending Product Variant Approval List
            </p>
          </div>
          <div className="p-2 pt-5  ">
            <div className="flex items-center p-2 h-14 !bg-slate-100 border-zinc-600">
              {/* <input
                type="text"
                className="!border-3 !border-black px-2 !w-64 rounded-md py-1"
                placeholder="search"
                style={{ border: "1px solid black" }}
              /> */}
            </div>
          </div>
        </div>
        <div className="">
          <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="w-16"> Id</div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="w-36">STORE NAME </div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="w-40">VARIANT NAME</div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="w-28">ACTUAL PRICE</div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="w-24">M.R.P.</div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="w-36">QUANTITY</div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    STATUS
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data &&
                  data.map((row) => (
                    <TableRow
                      key={row?.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.id ? row?.id : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.store?.store_name ? row?.store?.store_name : "--"}
                      </TableCell>

                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.product_variant_name
                          ? row?.product_variant_name
                          : "--"}
                        <span> </span>
                        {row?.last_name ? row?.last_name : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.price ? row?.price : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.mrp ? row?.mrp : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.quantity ? row?.quantity : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        <button
                          className="bg-red-500 px-2 p-1 rounded text-white font-bold"
                          onClick={() => approvadData(row?.id)}
                        >
                          APPROVAL
                        </button>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </>
  );
};

export default WalletManagement;
